import { attr } from '@ember-data/model';
import EmberDataBaseFragment from '@square/dashboard-data/models/ember-data-base-fragment';
export default EmberDataBaseFragment.extend({
  definitionToken: attr('string'),
  unitToken: attr('string'),
  intValue: attr('number'),
  stringValue: attr('string')
}).reopenClass({
  _modelNameForMigration: 'squareup/inventory/v3/catalog-object-attribute'
});